// extracted by mini-css-extract-plugin
export var childrenContainer = "_c4-0";
export var virtualScrollArea = "_c4-1";